// Generated by `apply-app gen-telemetry-ts` from apply_app/telemetry/events.py.
// Do not edit.

export const Event = {
  SIGNIN_STARTED: "signin_started",
  CONSENT_GIVEN: "consent_given",
  OAUTH_DONE: "oauth_done",
  CV_UPLOADED: "cv_uploaded",
  TOKEN_ISSUED: "token_issued",
  TOKEN_REGENERATED: "token_regenerated",
  THINKING_SUBMITTED: "thinking_submitted",
  TELEMETRY_UNAVAILABLE: "telemetry_unavailable",
  LLM_CALL: "llm_call",
  REVIEW_OPENED: "review_opened",
  REVIEW_DECIDED: "review_decided",
  MCP_CONNECTED: "mcp_connected",
  TOOL_CALLED: "tool_called",
  TOOL_ERROR_RETURNED: "tool_error_returned",
  RESOURCE_READ: "resource_read",
  ANSWER_LINK_ISSUED: "answer_link_issued",
  EGG_FOUND: "egg_found",
  Q_SHOWN: "q_shown",
  FIRST_KEYSTROKE: "first_keystroke",
  TYPING_BATCH: "typing_batch",
  PASTE: "paste",
  FOCUS_LOST: "focus_lost",
  FOCUS_BACK: "focus_back",
  Q2_TAG_CHOSEN: "q2_tag_chosen",
  Q_SUBMITTED: "q_submitted",
  EGG_WORD_ENTERED: "egg_word_entered",
  VOICE_STARTED: "voice_started",
  VOICE_STAGE: "voice_stage",
  VOICE_ENDED: "voice_ended",
} as const;

export type EventName = (typeof Event)[keyof typeof Event];

export const BROWSER_EVENTS: readonly EventName[] = [
  "egg_word_entered",
  "first_keystroke",
  "focus_back",
  "focus_lost",
  "paste",
  "q2_tag_chosen",
  "q_shown",
  "q_submitted",
  "typing_batch",
];
